import { useState, useEffect } from 'react';

export const useResponsiveModalWidth = (defaultWidth = 600) => {
  const [width, setWidth] = useState(defaultWidth);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 480) setWidth(`90%`); // Full width
      else if (window.innerWidth < 768) setWidth(Math.floor(window.innerWidth * 0.9));
      else setWidth(defaultWidth);
    };

    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [defaultWidth]);
  return width;
};
